import type {Components, Theme} from '@mui/material';
import {alertClasses} from '@mui/material';
import DoneCircleBoldIcon from '@/modules/shared/ui/kit/icons/DoneCircleBold';
import ForbidenBoldIcon from '@/modules/shared/ui/kit/icons/ForbidenBold';
import InfoCircleIcon from '@/modules/shared/ui/kit/icons/InfoCircle';
import InfoCircleBoldIcon from '@/modules/shared/ui/kit/icons/InfoCircleBold';

export const MuiAlert = (theme: Theme): Components['MuiAlert'] => ({
  defaultProps: {
    iconMapping: {
      success: <DoneCircleBoldIcon />,
      info: <InfoCircleBoldIcon />,
      warning: <InfoCircleIcon />,
      error: <ForbidenBoldIcon />,
    },
  },
  styleOverrides: {
    root: {
      padding: 16,
      color: theme.palette.text2,
      borderRadius: +theme.shape.borderRadius * 2,
      ...theme.typography.CaptionRegular,
    },
    message: {
      padding: 0,
      alignSelf: 'center',
      ...theme.typography.CaptionMedium,
    },
    icon: {
      padding: 0,
      marginLeft: 0,
      marginRight: 8,
    },
    standardSuccess: {
      backgroundColor: theme.palette.approveBg4,
      color: theme.palette.approveText,
      [`.${alertClasses.icon}`]: {
        color: theme.palette.approveText,
      },
    },
    standardInfo: {
      backgroundColor: theme.palette.primaryBrandBg4,
      color: theme.palette.text1,
      [`.${alertClasses.icon}`]: {
        color: theme.palette.primaryBrandText,
      },
    },
    standardError: {
      backgroundColor: theme.palette.criticalBg3,
      color: theme.palette.criticalText,
      [`.${alertClasses.icon}`]: {
        color: theme.palette.criticalText,
      },
    },
    standardWarning: {
      backgroundColor: theme.palette.warningBg2,
      color: theme.palette.warningText,
      [`.${alertClasses.icon}`]: {
        color: theme.palette.warningText,
      },
    },
  },
});

export const MuiAlertTitle = (theme: Theme): Components['MuiAlertTitle'] => ({
  styleOverrides: {
    root: {
      marginBottom: 0,
      marginTop: 0,
      ...theme.typography.BodyRegular,
    },
  },
});
